export class LoginCredentials {
    username: string | undefined;
    password: string | undefined;
    companyId: number | undefined;
    companySiteId: number | undefined;
    refresh : string | undefined;
    constructor() {}
}
